"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var owa_mail_folder_forest_store_1 = require("owa-mail-folder-forest-store");
var Store_1 = require("owa-mail-list-store/lib/store/Store");
var owa_mail_module_orchestrator_1 = require("owa-mail-module-orchestrator");
var owa_mail_reading_pane_store_1 = require("owa-mail-reading-pane-store");
var MailListItemSelectionSource_1 = require("owa-mail-store/lib/store/schema/MailListItemSelectionSource");
var Store_2 = require("owa-mail-store/lib/store/Store");
var conversationsUtils_1 = require("owa-mail-store/lib/utils/conversationsUtils");
var getFormattedDate_1 = require("owa-mail-store/lib/utils/getFormattedDate");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var React = require("react");
var styles = require('./MailListItemExpansion.scss');
var classNames = require('classnames/bind');
var MailListItemExpansion = /** @class */ (function (_super) {
    tslib_1.__extends(MailListItemExpansion, _super);
    function MailListItemExpansion() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderItemPart = function (nodeId) {
            var item = conversationsUtils_1.getItemFromNodeId(nodeId);
            var senderName;
            var timeText;
            var parentFolder;
            var itemPartClasses;
            var itemPartContentClasses;
            var senderClasses;
            if (item) {
                senderName = item.From && item.From.Mailbox && item.From.Mailbox.Name;
                parentFolder = Store_2.default.folders.folderTable.get(item.ParentFolderId.Id);
                timeText =
                    !parentFolder || owa_mail_folder_forest_store_1.getFolderIdForSelectedNode() == parentFolder.FolderId.Id
                        ? getFormattedDate_1.default(item.DateTimeReceived)
                        : parentFolder.DisplayName;
                itemPartClasses = classNames(styles.itemPart, !item.IsRead && styles.unread);
                itemPartContentClasses = classNames(_this.props.isSingleLine
                    ? styles.itemPartContentSingleLine
                    : styles.itemPartContentThreeColumn, item.IsDraft && styles.itemPartContentDraft);
                senderClasses = classNames(!item.IsRead ? styles.senderUnread : styles.sender, item.IsDraft && styles.draft);
            }
            return (item && (React.createElement("div", { key: item.ItemId.Id, className: itemPartClasses, onClick: function () {
                    _this.onItemPartClicked(item.ItemId.Id);
                } },
                React.createElement("div", { className: itemPartContentClasses },
                    React.createElement("span", { className: senderClasses }, item.IsDraft ? owa_mail_strings_1.default.draftSenderPersonaPlaceholder : senderName),
                    React.createElement("span", { className: styles.time }, timeText)))));
        };
        return _this;
    }
    MailListItemExpansion.prototype.render = function () {
        var conversationItem = Store_1.default.conversationItems.get(this.props.conversationId);
        var displayItemParts = conversationItem.globalItemIds.length > 1;
        var conversationItemParts = Store_2.default.conversations.get(conversationItem.id);
        return (displayItemParts && (React.createElement("div", { className: styles.expansionContainer }, conversationItemParts &&
            conversationItemParts.conversationNodeIds.length > 0 &&
            conversationItemParts.conversationNodeIds.map(this.renderItemPart))));
    };
    MailListItemExpansion.prototype.onItemPartClicked = function (itemId) {
        var tableView = Store_1.default.tableViews.get(this.props.tableViewId);
        owa_mail_module_orchestrator_1.onListViewSelectionChange(tableView, true /* isUserNavigation */, MailListItemSelectionSource_1.default.MailListItemExpansion);
        owa_mail_reading_pane_store_1.lazySetItemIdToScrollTo.importAndExecute(itemId);
    };
    MailListItemExpansion = tslib_1.__decorate([
        mobx_react_1.observer
    ], MailListItemExpansion);
    return MailListItemExpansion;
}(React.Component));
exports.default = MailListItemExpansion;
//# sourceMappingURL=MailListItemExpansion.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-list-view/lib/components/MailListItemExpansion.js
// module id = 5991
// module chunks = 78